class CartRecommendationsHeading extends HTMLElement {
  connectedCallback() {
    this.style.display = 'contents';
    this.timer = this.querySelector('[data-timer]');

    if (this.timer) {
      const { year, month, day } = this.timer.dataset;

      if (year && month && day) {
        this.endDate = new Date(year, month - 1, day);
        this.updateTimer();
        this.interval = setInterval(() => this.updateTimer(), 1000);
      } else {
        this.updateDailyTimer();
        this.interval = setInterval(() => this.updateDailyTimer(), 1000);
      }
    }
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateTimer() {
    const now = new Date();
    const distance = this.endDate - now;

    if (distance < 0) {
      this.timer.textContent = '0d : 0h : 0m : 0s';
      clearInterval(this.interval);
      this.interval = null;
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.timer.textContent = `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
  }

  updateDailyTimer() {
    const now = new Date();

    // Calculate midnight tonight in user's local timezone
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);

    const distance = midnight - now;

    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.timer.textContent = `${hours}h : ${minutes}m : ${seconds}s`;
  }
}

customElements.define('cart-recommendations-heading', CartRecommendationsHeading);
